<button mat-icon-button class="no-hover-effect analysis-button searchbox-shadow" [routerLink]="[router_link]">
    <mat-icon>close</mat-icon>
</button>